import React from 'react';
import styled, { keyframes } from 'styled-components';
import { HrButtons, HrIconButton, HrPrimary, HrSecondary, HrWhite } from '@components/styles/hr-styles';

const Spin = keyframes` 100% { transform: rotate(360deg)} `;

const Spinner = styled.span`
  animation: ${Spin} 4s linear infinite;

  ${({ category }) =>
    category === 'primary' &&
    `
    color: ${HrWhite} !important;
  `}

  ${({ category }) =>
    category === 'secondary' &&
    `
    color: ${HrWhite} !important;
  `}

  ${({ category }) =>
    category === 'tertiaryGreen' &&
    `
    color: ${HrPrimary} !important;
  `}

  ${({ category }) =>
    category === 'tertiaryGray' &&
    `
    color: ${HrSecondary} !important;
  `}
`;

export const HrButton = ({
  type,
  name,
  onClick,
  text,
  category,
  size,
  padding,
  preIcon,
  posIcon,
  iconColor,
  disabled,
  width,
  loading,
  className,
  fontSize
}) => {
  const onClickCustom = (e) => {
    if (onClick) {
      onClick();
    }
  };
  // ESTA RE MAL PASARLE POR PROPS SI LA VISTA ES UN BORRADOR O NO, PERO NO TENGO TIEMPO, DESPUES LO VEMOS

  return (
    <HrButtons
      className={className}
      type={type}
      name={name}
      onClick={(e) => {
        onClickCustom(e);
      }}
      style={{fontSize: fontSize}}
      category={category}
      size={size}
      padding={padding}
      disabled={disabled}
      width={width}
    >
      {preIcon && <HrIconButton className={preIcon} iconColor={iconColor} />}
      {loading ? (
        <>
          <Spinner className='hr-Charge' category={category} />
          {text}
        </>
      ) : (
        text
      )}
      {posIcon && <HrIconButton className={posIcon} iconColor={iconColor} />}
    </HrButtons>
  );
};
